import { Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { FormBuilder } from '@angular/forms'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { Resource, SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-checkbox-placeholder',
  templateUrl: './checkbox-placeholder.component.html',
  styleUrls: ['./checkbox-placeholder.component.scss', '../global-fields.scss'],
})
export class CheckboxPlaceholderComponent extends FieldPlaceholderComponent {
  type = SignFieldType.Checkbox

  @Input() required = true
  @Input() label: string

  disableCustomFont = true

  readonly uncheckboxDataURI = Resource.CHECKBOX_UNCHECKED_DATA_URI

  constructor(
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }
}
